import { useEffect } from 'react'
import { Grid, H, P } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'
import { useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import ENV from 'config/environment'

import SelectInput from 'components/form/select-input'
import { AdminUser } from 'lib/models/admin-user'
import { formatAdminUserOptions } from 'utils/helpers'
import { updateProbateCase } from 'state/actions'
import { ProbateCase } from 'lib/models/probate-case'
import { noop } from 'lib/functions/noop'
import { scrollToDataId } from 'lib/window/scroll'

import CaseSupervisor from './case-supervisor'

const CaseOwnerSection = () => {
  const dispatch = useDispatch()
  const probateCase = useSelector(
    (state: { probateCase: ProbateCase }) => state.probateCase
  )
  const cache = useQueryClient()
  const adminUsers = cache.getQueryData('adminUsers') as AdminUser[]
  const users = ENV.PROBATE_OWNERS_GROUP
    ? adminUsers.filter((u) =>
        u.attributes.microsoftGroups.includes(ENV.PROBATE_OWNERS_GROUP)
      )
    : adminUsers
  const adminUserOptions = formatAdminUserOptions(users)

  const handleOwnerChange = (ownerId: number) => {
    if (!ownerId) return
    dispatch(
      updateProbateCase(probateCase.id, {
        postReferralOwnedByAdminUserId: ownerId,
      })
    )
  }

  return (
    <Formik
      initialValues={{
        postReferralOwnedByAdminUserId:
          probateCase.attributes.postReferralOwnedByAdminUserId,
      }}
      validationSchema={Yup.object().shape({
        postReferralOwnedByAdminUserId: Yup.number().required(),
      })}
      onSubmit={noop}
      enableReinitialize
    >
      <Form>
        <H size="XS">Case Owner</H>
        <P color={COLOR.GREY.DARK}>
          This is the person handling day-to-day case management tasks.
        </P>
        <Grid>
          <Grid.Item span={6}>
            <SelectInput
              name="postReferralOwnedByAdminUserId"
              options={adminUserOptions}
              handleSave={({ value }) => handleOwnerChange(value as number)}
              isClearable
            />
          </Grid.Item>
        </Grid>
      </Form>
    </Formik>
  )
}

const Ownership = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      scrollToDataId(location.hash.replace('#', ''))
    }
  }, [location.hash])

  return (
    <>
      <Grid.Item>
        <H size="S">Ownership</H>
      </Grid.Item>
      <Grid.Item data-scroll-id="case-supervisor">
        <CaseSupervisor />
      </Grid.Item>
      <Grid.Item>
        <CaseOwnerSection />
      </Grid.Item>
    </>
  )
}

export default Ownership
